import { render, staticRenderFns } from "./SupportOverview.vue?vue&type=template&id=4a7fa2ed&"
import script from "./SupportOverview.vue?vue&type=script&lang=ts&"
export * from "./SupportOverview.vue?vue&type=script&lang=ts&"
import style0 from "./SupportOverview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports